import { ParseToNumber } from "../../../../utils/tools"
import { SingletonEnginnering } from "../../singletonEngineering"

const TurnOffSuffixation = {
  CheckAndTurnOf:function (inputsToSend) {
    try{
      let cols = SingletonEnginnering.operations.filter(name => name.match(/ColunaAbsorcao/))
      if(!cols.length) return

      cols.forEach(col => {
        let operationsColAndDivider = this.findObjects(col)
        let EnabledReactor = this.findPropEnableReactor(col)
        let EnabledCol = this.findPropEnable(operationsColAndDivider, col)
        let dividerIsClosed = this.checkDivisorIsClosed(inputsToSend, operationsColAndDivider, col)

        if(dividerIsClosed){
          EnabledCol.value = "false"
          EnabledReactor.value = "false"
          inputsToSend.push(EnabledCol)
          inputsToSend.push(EnabledReactor)
        }else{
          EnabledCol.value = "true"
          EnabledReactor.value = "true"
          inputsToSend.push(EnabledCol)
          inputsToSend.push(EnabledReactor)
        }
      })
    }
    catch(e){
      console.warn(`Falha em TurnOffSuffixation\nErro: ${e}`)
    }
  },

  findObjects(col){
    let current = SingletonEnginnering.getCurrentByInputOfOperation(col, 2)
    return SingletonEnginnering.getAttributesOfOperationByCurrent(current)
  },

  findPropEnableReactor(col){
    let current = SingletonEnginnering.getCurrentByInputOfOperation(col, 1)
    let operations = SingletonEnginnering.getAttributesOfOperationByCurrent(current)
    let reactor = operations.find(obj => obj.index != col)
    return this.findPropEnable(operations, reactor.index)
  },

  findPropVmC(operations, col){
    let propsDiv = operations.find(obj => obj.index != col)
    return propsDiv.attrs.find(at => at.key == 'vmC')
  },

  findPropEnable(operations, index){
    let props = operations.find(obj => obj.index == index)
    return props.attrs.find(at => at.key == "Enabled")
  },

  checkDivisorIsClosed(inputsToSend, operations, col){
    let vmC = this.findPropVmC(operations, col)
    let divisorVmC = inputsToSend.find(at => at.isEquals(vmC))
    return !ParseToNumber(divisorVmC.value)
  }
}

export default TurnOffSuffixation